import { render } from "./AbandonedValley.vue?vue&type=template&id=b3cbdacc"
import script from "./AbandonedValley.vue?vue&type=script&lang=js"
export * from "./AbandonedValley.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AbandonedValley.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b3cbdacc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b3cbdacc', __exports__)) {
    api.reload('b3cbdacc', __exports__)
  }
  
  module.hot.accept("./AbandonedValley.vue?vue&type=template&id=b3cbdacc", () => {
    api.rerender('b3cbdacc', render)
  })

}


export default __exports__